import { render, staticRenderFns } from "./allienceMienList.vue?vue&type=template&id=9e4a08da&scoped=true"
import script from "./allienceMienList.vue?vue&type=script&lang=js"
export * from "./allienceMienList.vue?vue&type=script&lang=js"
import style0 from "./allienceMienList.vue?vue&type=style&index=0&id=9e4a08da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e4a08da",
  null
  
)

export default component.exports